import { createSlice } from '@reduxjs/toolkit';
import { computeCompareDateRange } from 'utilities/utilities_exports';
import moment from 'moment';

// Helper Function to Get Default Date Range
const getLast7DaysRange = () => {
  const endDate = moment().subtract(1, 'days'); // Yesterday
  const startDate = moment(endDate).subtract(6, 'days'); // 7 days ago (including endDate)
  return [startDate, endDate];
};

// Initial State
const initialState = {
  dateRange: getLast7DaysRange(),
  comparedDateRange: computeCompareDateRange(getLast7DaysRange()),
  chartGranularity: null,
  dateRangeDuration: null,
  comparedDateRangeVisible: false
};

const dateRangeSlice = createSlice({
  name: 'dateRange',
  initialState,
  reducers: {
    updateDateRangeState(state, action) {
      console.log(action?.payload);
      return { ...state, ...action.payload };
    }
  }
});

// Export actions
export const { updateDateRangeState } = dateRangeSlice.actions;

// Export reducer
export default dateRangeSlice.reducer;
